/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$('#read-more').click(function(){
  $('#short-description').css("display", "none");
  $('#long-description').css("display", "block");
});

$('#read-less').click(function(){
  $('#short-description').css("display", "block");
  $('#long-description').css("display", "none");
});

$(document).on("click", "#CybotCookiebotDialogBodyEdgeMoreDetailsLink", function(){  
  $("#CybotCookiebotDialog").attr("data-template","popup");
  // if (!'Cookiebot' in window || !'CookiebotDialog' in window) return; 
});

/*
* Cookie Utilities
* Inspired by https://www.tutorialrepublic.com/javascript-tutorial/javascript-cookies.php
*/
function setCookie(name, value, daysToLive = 365, path = '/') {
  let cookie = name + "=" + encodeURIComponent(value);
  if (typeof daysToLive === "number") {
      cookie += "; max-age=" + (daysToLive*24*60*60);
      cookie += "; path=" + path;
      document.cookie = cookie;
  }
}

function getCookie(name) {
  const cookieArr = document.cookie.split(";");
  for (let i = 0; i < cookieArr.length; i++) {
    const cookiePair = cookieArr[i].split("=");
    if (name == cookiePair[0].trim()) {
      return decodeURIComponent(cookiePair[1]);
    }
  }
  return null;
}

function checkCookieExists(name) {
  const cookie = getCookie(name);
  return cookie ? true : false;
}

function isRlxCollectionPage() {
  const rlxCollectionPathName = '/pages/rolex-collection';
  const pagePathName = window.location.pathname;
  return pagePathName === rlxCollectionPathName || pagePathName === `${rlxCollectionPathName}/`;
}

// set rlx-consent cookie if not already defined.
// console.log(`Path Name is Rlx collection? ${isRlxCollectionPage()}`);
const rlxConsent = 'rlx-consent';
if (!checkCookieExists(rlxConsent)) {
  setCookie(rlxConsent, false);
  if (!typeof _satellite === 'undefined') {
    _satellite.setVar('Analyticsconsent', 'false');
  } else {
    document.addEventListener('launchTrackingReady', () => {
      _satellite.setVar('Analyticsconsent', 'false');
    });
  }
}

// set tracking declined global, set to true if tracking active when page was loaded but declined then after.
window.trackingDeclined = null;

// cookiebot listener
window.addEventListener('CookiebotOnAccept', (e) => {
  if (Cookiebot.consent.statistics) {
    setCookie(rlxConsent, true);
    if (typeof _satellite !== 'undefined') {
      _satellite.setVar('Analyticsconsent', 'true');
    } else {
      document.addEventListener('launchTrackingReady', () => {
        _satellite.setVar('Analyticsconsent', 'true');
      });
    }
  } else {
    setCookie(rlxConsent, false);
    if (typeof _satellite !== 'undefined') {
      _satellite.setVar('Analyticsconsent', 'false');
    } else {
      document.addEventListener('launchTrackingReady', () => {
        _satellite.setVar('Analyticsconsent', 'false');
      });
    }
  }
}, false);

window.addEventListener('CookiebotOnDecline', () => {
  window.trackingDeclined = true;
  if (typeof _satellite !== 'undefined') {
    _satellite.setVar('Analyticsconsent', 'false');
  } else {
    document.addEventListener('launchTrackingReady', () => {
      _satellite.setVar('Analyticsconsent', 'false');
    });
  }
  setCookie(rlxConsent, false);
}, false);

function runWhenSatellite() {
  if (Cookiebot.consent.statistics) {
    if (typeof _satellite !== 'undefined' && window.trackingDeclined !== true) {
      _satellite.setVar('Analyticsconsent', 'true');
      if (typeof submitPageViewTracking !== 'undefined' && submitPageViewTracking === true) {
        _satellite.track('PageView');
      }
    }
  }
}

document.addEventListener('launchTrackingReady', () => {
  console.log('got _satellite');
  runWhenSatellite();
});
